import { Link } from 'react-router-dom';
import { shows } from '@/mocks/shows';
import ShowCard from '@/components/base/ShowCard';

export default function FeaturedShows() {
  const featured = shows.filter(s => s.isHot).slice(0, 6);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="精选推荐">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-500">编辑精选，不容错过的热门综艺</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop>
          {featured.map(show => (
            <ShowCard key={show.id} show={show} />
          ))}
        </div>
      </div>
    </section>
  );
}